import React, { useState } from 'react';
import { useField } from "formik";
import { Alert } from 'reactstrap';

// User messages of all kind
export const AlertUser = (props) => {
  const [visible, setVisible] = useState(true);

  const onDismiss = () => { 
    setVisible(false);
    // wait for fade-out before trigger re-rendering
    setTimeout(() => { props.action() }, 600);
  }

  return (
    <Alert color={props.type} isOpen={visible} toggle={onDismiss} className="container-fluid">
      {props.txt}
    </Alert>
  );
}
export default AlertUser;


// element: input text
export const TextInput = ({ label, ...props }) => {
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    const [field, meta] = useField(props);
    return (
      <>
        <div className="m-0 p-0"> 
          <input className="text-input" {...field} {...props} />
          {meta.touched && meta.error ? ( <div className="error">{meta.error}</div>) : null}
        </div>
      </>
    );
  };

// element: checkboxes 
//export const Checkbox = ({ children, ...props }) => {
//  const [field, meta] = useField({ ...props, type: "checkbox" });
//  console.log(children);
//
//  return (
//      <div className="checkbox">
//        <label> 
//          <input {...field} {...props} type="checkbox" /> {children} 
//        </label>
//        {meta.touched && meta.error ? (<div className="error">{meta.error}</div>) : null}
//      </div>
//  );
//};
